import React, { useState } from "react";
import * as utils from "../utils/utils";
import PrimaryButton from "./Button/PrimaryButton";

export default function UploadFile({
  formikState,
  fileLogData,
  setFileLogData,
}) {
  const handleFileSelect = async () => {
    const fileData = await utils?.fileSelectHandler("application/pdf");
    formikState?.setFieldValue("cmrCopy", fileData?.fileDetail);
    setFileLogData(fileData);
  };
  return (
    <div className="flex gap-5 items-center">
      <PrimaryButton
        size={"large"}
        name={"Upload CMR"}
        height={"50px"}
        borderRadius={"10px"}
        handleOnClick={handleFileSelect}
        width={"50%"}
      />
      {/* Display the file name if available */}
      {fileLogData ? (
        <span className="text-black mt-2">
          {fileLogData?.fileDetail?.name || "No file selected"}
        </span>
      ) : (
        <span className="text-black mt-2">No file selected</span>
      )}
    </div>
  );
}
